import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'controller/utils/@reduxjs/toolkit';
import {
  useInjectReducer,
  useInjectSaga,
} from 'controller/utils/redux-injectors';
import { success, error } from 'core/components/Notify';

import CustomResponse from 'core/utils/types/CustomResponse';
import { branchSetupSaga } from './saga';
import { BranchSetup, BranchSetupState } from './types';
import { convertNaNIntoNumber } from 'core/utils/constants';

export const initialState: BranchSetupState = {

  callView: false,
  callMainAPI: false,
  callViewAPI: false,

  notificationLoader: false,
  branchDataList: [],
  listResponse: null,
  branchDataViewList: [],
  viewListResponse: null,
  isLoadingbranchDataList: false,
  socialSuccess: false,
  errorbranchDataList: undefined,

  branchModalDataList: [],
  listModalResponse: null,
  isLoadingbranchModalDataList: false,
  errorbranchModalDataList: undefined,

  pageIndex: 0,
  pageSize: 10,

  websitePreviewData: undefined,

  youtubeData: undefined,
  branchData: undefined,
  isLoadingbranchData: false,
  isUpsertLoading: false,
  isCustomLoadingData: false,
  errorbranchData: undefined,

  branchDataAttendence: undefined,
  isLoadingbranchDataAttendence: false,
  errorbranchDataAttendence: undefined,

  navigate: false,
  isDeletedBranchData: false,
  isDeletingBranchData: false,
  errorDeletingBranchData: {} as CustomResponse,
};

const slice = createSlice({
  name: 'branchSetup',
  initialState,
  reducers: {
    fetchBranchSetupListStart(
      state,
      action: PayloadAction<{
        ID: number;
        URL: string;
        ACADEMIC_YEAR_ID?: number;
        column?: string;
        keyword?: number | string;
        ADMISSION_FILTER?: string;
        TABLE_CALL?: boolean;
        TABLE_DATA?: { page_size?: string | number, page_index?: string | number }
        query?: string;
        domainName?: string;
        START_DATE?: string;
        END_DATE?: string;
        moduleAction?: string;
        userActivityModule?: string;
        action?: "VIEW_API_CALL" | "VIEW_AND_LIST_API_CALL";
        storeListInDifferentState?: boolean;
      }>,
    ) {
      if (action?.payload?.action === "VIEW_API_CALL") {
        state.callViewAPI = false;
      } else if (action?.payload?.action === "VIEW_AND_LIST_API_CALL") {
        state.callMainAPI = false;
        state.callViewAPI = false;
      } else {
        state.callMainAPI = false;
      }
      if (!action?.payload?.TABLE_CALL) {
        state.callView = false;
        state.isDeletedBranchData = false;
        state.isLoadingbranchDataList = true;
      } else {
        state.pageIndex = convertNaNIntoNumber(Number(action?.payload?.TABLE_DATA?.page_index));
        state.pageSize = convertNaNIntoNumber(Number(action?.payload?.TABLE_DATA?.page_size));
      }
    },
    fetchBranchSetupListSuccess(state, action: PayloadAction<{ listData: [], data: object, storeListInDifferentState?: boolean }>) {
      state.isLoadingbranchDataList = false;
      if (action.payload?.storeListInDifferentState) {
        state.branchDataViewList = action.payload?.listData;
        state.viewListResponse = action.payload?.data;
      } else {
        state.branchDataList = action.payload?.listData;
        state.listResponse = action.payload?.data;
      }
    },
    fetchBranchSetupListFailure(state, action: PayloadAction<CustomResponse>) {
      state.isLoadingbranchDataList = false;
      state.errorbranchData = action.payload;
    },

    fetchBranchSetupModalListStart(
      state,
      action: PayloadAction<{
        ID: number;
        URL: string;
        ACADEMIC_YEAR_ID?: number;
        column?: string;
        keyword?: number | string;
        ADMISSION_FILTER?: string;
        TABLE_CALL?: boolean;
        TABLE_DATA?: { page_size?: string | number, page_index?: string | number }
      }>,
    ) {
      state.callMainAPI = false;
      state.isDeletedBranchData = false;
      state.isLoadingbranchModalDataList = true;
    },
    fetchBranchSetupModalListSuccess(state, action: PayloadAction<{ listData: [], data: object }>) {
      state.isLoadingbranchModalDataList = false;
      state.branchModalDataList = action.payload?.listData;
      state.listModalResponse = action.payload?.data;
    },
    fetchBranchSetupModalListFailure(state, action: PayloadAction<CustomResponse>) {
      state.isLoadingbranchModalDataList = false;
      state.errorbranchModalDataList = action.payload;
    },

    fetchBranchSetupOneStart(
      state,
      action: PayloadAction<{ ID: number; URL: string }>,
    ) {
      state.callView = false;
      state.callViewAPI = false;
      state.isLoadingbranchData = true;
      state.isDeletedBranchData = false;
    },
    fetchBranchSetupOneSuccess(state, action: PayloadAction<BranchSetup>) {
      state.isLoadingbranchData = false;
      state.branchData = action.payload;
      state.listResponse = action.payload;
    },
    fetchBranchSetupOneFailure(state, action: PayloadAction<CustomResponse>) {
      state.isLoadingbranchData = false;
      state.errorbranchData = action.payload;
    },
    fetchBranchSetupOneStartAttendence(
      state,
      action: PayloadAction<{ ID: number | string; URL: string; ACADEMIC_YEAR_ID: number | string }>,
    ) {
      state.callMainAPI = false;
      state.callViewAPI = false;
      state.isLoadingbranchData = true;
    },
    fetchBranchSetupOneStartAttendenceSuccess(state, action: PayloadAction<BranchSetup>) {
      state.isLoadingbranchData = false;
      state.branchDataAttendence = action.payload;
    },
    fetchBranchSetupOneStartAttendenceFailure(state, action: PayloadAction<CustomResponse>) {
      state.isLoadingbranchData = false;
      state.errorbranchData = action.payload;
      state.branchDataAttendence = {};
    },
    saveYoutubeDataStart(
      state,
      action: PayloadAction<{
        URL: string;
        data: BranchSetup | unknown;
        action?: string;
        message: string;
      }>,
    ) {
      state.youtubeData = action?.payload?.data;
    },
    createBranchSetupStart(
      state,
      action: PayloadAction<{
        URL: string;
        data: BranchSetup | unknown;
        action?: "NOT_CALL" | "NOTIFICATION" | "CALL_VIEW_AND_MAIN_API_AFTER_FORM_SUBMIT" | "CALL_VIEW_API" | string;
        message: string;
        notificationReadAll?: boolean;
      }>,
    ) {
      state.errorbranchData = undefined;
      if (action?.payload?.action === "NOT_CALL") {
        state.isCustomLoadingData = true;
      } else if (action?.payload?.action === "NOTIFICATION") {
        state.notificationLoader = true;
      } else {
        state.isUpsertLoading = true;
      }
    },
    createBranchSetupSuccess(state, action: PayloadAction<{ flag?: boolean, message: string, action?: "NOT_CALL" | "NOTIFICATION" | "CALL_VIEW_AND_MAIN_API_AFTER_FORM_SUBMIT" | "CALL_VIEW_API" | string }>) {
      state.callView = true;
      if (action.payload?.flag) {
        state.socialSuccess = true;
        state.isCustomLoadingData = false;
        state.notificationLoader = false;
        if (action.payload.message) {
          success(action.payload.message, true);
        }
      } else {
        state.notificationLoader = false;
        state.isUpsertLoading = false;
        state.navigate = true;
        if (action?.payload?.action === "CALL_VIEW_AND_MAIN_API_AFTER_FORM_SUBMIT") {
          state.callMainAPI = true;
          state.callViewAPI = true;
        } else if (action?.payload?.action === "CALL_VIEW_API") {
          state.callViewAPI = true;
        } else {
          state.callMainAPI = true;
        }
      }
      // success(action.payload, true);
    },
    createBranchSetupFailure(state, action: PayloadAction<CustomResponse>) {

      state.isUpsertLoading = false;
      state.isCustomLoadingData = false;
      state.notificationLoader = false;
      state.socialSuccess = false;
      state.errorbranchData = action.payload;
      error(action.payload, true);
    },

    deleteBranchSetupStart(
      state,
      action: PayloadAction<{ URL: string; ID: number, action?: string }>,
    ) {
      state.errorDeletingBranchData = undefined;
      if (action?.payload?.action === "NOTIFICATION") {
        state.notificationLoader = true;
      } else {
        state.isDeletingBranchData = true;
      }
    },
    deleteBranchSetupSuccess(state) {
      state.isDeletingBranchData = false;
      state.isDeletedBranchData = true;
      state.notificationLoader = false;
      success('Deleted Successfully', true);
      // successfully Deleted | Alert Message
    },
    deleteBranchSetupFailure(state, action: PayloadAction<CustomResponse>) {
      state.isDeletingBranchData = false;
      state.notificationLoader = false;
      state.errorDeletingBranchData = action.payload;
    },

    updateWebsiteData(state, action: PayloadAction) {
      state.websitePreviewData = action.payload
    },

    clearBranchViewEditData(state) {
      state.branchData = undefined;
      state.branchDataViewList = [] as BranchSetup[];
      state.viewListResponse = undefined;
      state.isLoadingbranchData = false;
      state.isCustomLoadingData = false;
      state.notificationLoader = false;
    },

    clearBranchData(state) {
      state.branchDataList = [] as BranchSetup[];
      state.branchDataViewList = [] as BranchSetup[];
      state.viewListResponse = undefined;
      state.branchData = undefined;
      state.listResponse = undefined;
      state.isLoadingbranchData = false;
      state.isCustomLoadingData = false;
      state.socialSuccess = false;
      state.pageIndex = 0;
      state.pageSize = 10;
      state.notificationLoader = false;
    },

    clearState(state) {
      state.branchDataList = [];
      state.branchDataViewList = [] as BranchSetup[];
      state.viewListResponse = undefined;
      state.branchData = undefined;
      state.listResponse = undefined;
      state.isLoadingbranchData = false;
      state.isCustomLoadingData = false;
      state.socialSuccess = false;
      state.notificationLoader = false;
      state.pageIndex = 0;
      state.pageSize = 10;
    },

    clearModalState(state) {
      state.branchModalDataList = [];
      state.listModalResponse = null;
      state.isLoadingbranchModalDataList = false;
      state.errorbranchModalDataList = undefined;
      state.socialSuccess = false;
      state.notificationLoader = false;
    },

    clearSocialNetworkOnSuccess(state) {
      state.socialSuccess = false;
    },

    setNavigate(state, action: PayloadAction<boolean>) {
      state.navigate = action.payload;
    },
  },
});

export const { actions: branchSetupActions } = slice;

export const useBranchSetupSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: branchSetupSaga });
  return { actions: slice.actions };
};

